import { UserPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/betausers_/$userId/')({
  component: UserPage,
})
